import styled from 'styled-components'

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  > div {
    min-width: 100px;
    flex: 1;
    /* max-width: 240px; */
  }
`

export const TrashContainer = styled.div`
  cursor: pointer;
`
